import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateHourPickerComponent } from './date-hour-picker.component';
import { FormModule } from 'ZalamoLibrary/src/lib/ui/form/form.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MatNativeDateModule,
  NativeDateAdapter,
} from '@angular/material/core';
// import { LuxonDateAdapter } from '@ui/material-luxon-adapter';

class test extends NativeDateAdapter {
  getFirstDayOfWeek(): number {
    return 1;
  }
}
@NgModule({
  declarations: [DateHourPickerComponent],
  exports: [DateHourPickerComponent],
  imports: [
    CommonModule,
    FormModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatNativeDateModule,
  ],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'pl-PL' },
    {
      provide: DateAdapter,
      useClass: test,
    },
  ],
})
export class DateHourPickerModule {}
